import * as Contentful from 'contentful'
import * as CFRichTextTypes from '@contentful/rich-text-types'

import { TypeAssetImage } from './asset-image'
import { TypeAssetLottieAnimation } from './asset-lottie-animation'
import { TypeComponentCtaButton } from './component-cta-button'
import { TypeSectionFields } from './section'
import { TypeVariationContainerAuthAndDeviceTypeCta } from './variation-container-auth-and-device-type-cta'
import { TitleSize } from './typography'
import { TypeSocialShareWidget } from '@components/share-widget/social-share-widget'

export enum SectionHeroLayoutDir {
  Default = 'Default: Text on the left; Image on the right',
  Reversed = 'Reversed: Image on the left; Text on the right',
  Vertical = 'Vertical: Title above asset; centered',
  VerticalWide = 'Vertical: Title above asset; centered; Wide width',
}

export enum SectionHeroDynamicRenderAs {
  Bts2025AnimatedHero = 'bts2025AnimatedHero',
  Bts2025Keychain = 'bts2025Keychain',
  GrammarlyAtWork25 = 'GrammarlyAtWork25',
}

export interface TypeSectionHeroFields extends TypeSectionFields {
  layoutDirection: SectionHeroLayoutDir
  title: CFRichTextTypes.Document
  titleSize?: TitleSize
  seoTitle?: Contentful.EntryFields.Symbol
  description: CFRichTextTypes.Document
  image?: TypeAssetImage | TypeAssetLottieAnimation
  ctAs: TypeComponentCtaButton[] | TypeVariationContainerAuthAndDeviceTypeCta[] | undefined
  socialShareWidget?: TypeSocialShareWidget
  // #ToDo Introduce proper typings instead of unknown
  nt_experiences?: unknown[]
  dynamicRenderAs?: Array<SectionHeroDynamicRenderAs>
}

export type TypeSectionHero = Contentful.Entry<TypeSectionHeroFields>
